import { useState, useEffect } from 'react';
import api from '../config/api';
import { buildTicketCompetitionUiMap } from '../config/ticketCompetitionTeamsUi';

/**
 * Charge les listes équipe adverse depuis l’API (fusion base + défauts côté serveur).
 * En cas d’échec, garde les listes locales du fichier JSON sous src/data/.
 */
export function useTicketCompetitionTeams() {
  const [competitions, setCompetitions] = useState(() =>
    buildTicketCompetitionUiMap(null)
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/settings/ticket-competition-teams');
        if (
          cancelled ||
          !data?.teamsByCompetition ||
          typeof data.teamsByCompetition !== 'object'
        ) {
          return;
        }
        setCompetitions(buildTicketCompetitionUiMap(data.teamsByCompetition));
      } catch {
        /* comportement synchrone initial déjà affiché */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { competitions };
}
